// Considered: StatusFactorPanel inline content — rejected because PlaceholderFactorSourceSection
// is a distinct stateless molecule replacing per-type source sections. See spec Reuse Audit.
import React from 'react';
import { useTranslation } from 'localization';
import ButtonAtom from '../../atoms/Button/ButtonAtom';
import './PlaceholderFactorSourceSection.scss';

interface PlaceholderFactorSourceSectionProps {
  onOpenConfigure?: () => void;
}

const PlaceholderFactorSourceSection: React.FC<PlaceholderFactorSourceSectionProps> = ({
  onOpenConfigure,
}) => {
  const { t } = useTranslation();

  return (
    <div className="placeholder-factor-source-section">
      <p className="placeholder-factor-source-section__message">
        {t('statusFactors.summary.placeholderSource')}
      </p>
      <ButtonAtom
        type="button"
        variant="text"
        label={t('statusFactors.actions.configure')}
        className="placeholder-factor-source-section__configure-link"
        data-testid="placeholder-configure-link"
        onClick={() => onOpenConfigure?.()}
      />
    </div>
  );
};

export default PlaceholderFactorSourceSection;
